export class SecretQuestion {
    public Id: number;
    public Question: string;
    public Answer: string;
    public IsSelected: boolean;
    constructor(secretQuestion: SecretQuestion) {
        this.Id = secretQuestion.Id || 0;
        this.Question = secretQuestion.Question || "";
        this.Answer = secretQuestion.Answer || "";
        this.IsSelected = secretQuestion.IsSelected || false;
    }

}